import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-5 gap-4 p-4 bottom-0 w-full z-40 bg-white border-t shadow-inner"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
import { Team } from "@/modules/team/entity/Team";
import { app } from "@/di";
import { Season } from "@/modules/season/entity";
import { EventEmitter } from "@/modules/base/events";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
import { AfterSeasonEvaluationEvent } from "@/modules/season/events/AfterSeasonEvaluationEvent";
import MenuNavigation from "./MenuNavigation.vue";
import { db } from "@/modules/base/services/db";
import { persistDataSource } from "@/modules/database/services/db";
import NotificationTabbarItem from "@/modules/notifications/components/NotificationTabbarItem.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Tabbar',
  async setup(__props) {
    let __temp, __restore;
    const season = ref();
    const team = ref();
    const showNavigation = ref(false);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      season.value = await Season.current();
      team.value = await Team.findOne({
        where: {
          user: true
        }
      });
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff([AfterSeasonEvaluationEvent, AfterDayEvaluationEvent], refresh));
    const router = useRouter();
    const onClickContinue = async () => {
      if (season.value.isLastDay) {
        await router.push({
          name: 'evaluation'
        });
        return;
      }
      // @ts-ignore
      await router.push({
        name: 'evaluation',
        query: {
          start: true
        }
      });
    };
    const message = useMessage();
    const onClickPersistDataSource = async () => {
      await persistDataSource(db);
      message.success(translator.t('saved'));
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(MenuNavigation, {
        ref: "menuNavigation"
      }, null, 512), _createElementVNode("div", _hoisted_1, [_createVNode(_component_NButton, {
        text: "",
        onClick: _withModifiers(onClickPersistDataSource, ["prevent"])
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Save16Regular
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["onClick"]), _createVNode(NotificationTabbarItem), _createVNode(_component_NButton, {
        text: "",
        onClick: onClickContinue
      }, {
        default: _withCtx(() => [season.value.isLastDay ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _ctx.IconEnum.FlagCheckered
        }, null, 8, ["icon"])) : (_openBlock(), _createBlock(Icon, {
          key: 1,
          icon: _ctx.IconEnum.Play
        }, null, 8, ["icon"]))]),
        _: 1
      }), _createVNode(_component_NButton, {
        text: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.$refs.menuNavigation.show(), ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Menu
        }, null, 8, ["icon"])]),
        _: 1
      }), _renderSlot(_ctx.$slots, "actionButton", {}, () => [_hoisted_2])])], 64);
    };
  }
});